import React from 'react';
import Div from '../Div';
import './timelineslider.css';


export default function TimelineSlider() {
  return (
    <Div className="timelineslider-content">
      <p>We build marketing engines fueled by equal parts code and creativity to help our partners achieve their vision. RLAB's solutions don't just perform - they captivate. RLAB develops scalable solutions that interweaves automation with human creativity, constructing hybrid ecosystems where legacy stability meets machine learning agility.</p>
    </Div>
  );
}
